var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * MicrophoneMuted component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMicrophoneMuted extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.145 1.25C9.57587 1.25 7.49316 3.33271 7.49316 5.90186V6.4325L2.53033 1.46967C2.23744 1.17678 1.76256 1.17678 1.46967 1.46967C1.17678 1.76256 1.17678 2.23744 1.46967 2.53033L21.7594 22.8201C22.0523 23.113 22.5272 23.113 22.8201 22.8201C23.113 22.5272 23.113 22.0523 22.8201 21.7594L18.5441 17.4834C20.5163 15.4088 20.6765 13.3103 20.6765 12.1089C20.6765 11.6947 20.3407 11.3589 19.9265 11.3589C19.5123 11.3589 19.1765 11.6947 19.1765 12.1089C19.1765 13.098 19.0653 14.7402 17.4829 16.4223L15.5673 14.5067C16.6382 13.3597 16.7667 12.1159 16.7969 11.5327V8.12758V5.90186C16.7969 3.33271 14.7142 1.25 12.145 1.25ZM14.5081 13.4475C14.9537 12.9918 15.271 12.209 15.2969 11.5327V5.90186C15.2969 4.16113 13.8857 2.75 12.145 2.75C10.4043 2.75 8.99316 4.16113 8.99316 5.90186V7.9325L14.5081 13.4475ZM9.28405 12.6761C9.11178 12.2994 8.66676 12.1336 8.29007 12.3059C7.91338 12.4782 7.74766 12.9232 7.91993 13.2999C8.39521 14.3392 9.23642 15.1671 10.2831 15.6258C10.6625 15.7921 11.1048 15.6194 11.2711 15.24C11.4373 14.8606 11.2646 14.4183 10.8852 14.252C10.176 13.9412 9.60607 13.3802 9.28405 12.6761ZM12.8948 19.9065C13.2078 19.8943 13.5303 19.8722 13.8626 19.8395C14.2749 19.799 14.5762 19.432 14.5357 19.0198C14.4952 18.6076 14.1282 18.3062 13.7159 18.3467C9.98986 18.7129 7.87983 17.6157 6.6845 16.2742C5.45518 14.8946 5.08882 13.1397 5.08887 12.062C5.08888 11.6478 4.75311 11.312 4.3389 11.312C3.92468 11.312 3.58888 11.6478 3.58887 12.062C3.58881 13.4022 4.02834 15.548 5.56459 17.2721C6.79447 18.6523 8.66541 19.6934 11.3948 19.8857V22.29C11.3948 22.7042 11.7306 23.04 12.1448 23.04C12.559 23.04 12.8948 22.7042 12.8948 22.29V19.9065Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMicrophoneMuted.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMicrophoneMuted.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMicrophoneMuted.prototype, "size", void 0);
if (customElements.get('cat-icon-microphone-muted') === undefined) {
    customElements.define('cat-icon-microphone-muted', BlocksIconMicrophoneMuted);
}
